import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { LeftOutlined } from '@ant-design/icons';
import { Card } from 'antd';
import SelectMerchant from '../select-merchant';
import { removeLoginData } from '../utils';
import { getSessionObject, Utils } from '@/tools/utils'
import './login-select.less'

const BackBtn = () => {
    const history = useHistory();

    return (
        <span className='back-btn' onClick={() => {
            Utils.customTrack('MerchantLoginSelectClick', {
                element_content: '返回'
            });
            // 删除loginData
            removeLoginData();
            history.goBack();
        }}>
            <LeftOutlined className='back-svg' />
            <span className='back-text'>返回</span>
        </span>
    );
};

const LoginSelect = () => {
    const history = useHistory();

    const loginData = getSessionObject('loginData') || {};

    // 检查是否允许进入该页面
    useEffect(() => {
        if (
            !loginData.merchants ||
            !Boolean(loginData.merchants.list)
        ) {
            history.replace('/login');
        };
    }, []);
    
    // 替换token后的操作
    const handleSelectMerchant = () => {
        Utils.customTrack('MerchantLoginSelectClick', {
            element_content: '点击选择商户'
        });
        history.replace('/homePage');
    };

    return (
        <div className='login-select-card-container' style={{ paddingRight: '8px' }}>
            <Card className='login-select-card' title={<BackBtn />}>
                <div className='head'>
                    <h2 className='head-title'>请选择账号所属商户</h2>
                </div>
                <div className="content">
                    {
                        loginData.merchants && loginData.merchants.list && 
                        <SelectMerchant onSelect={handleSelectMerchant}></SelectMerchant>
                    }
                </div>
            </Card>
        </div>
    )
};

export default LoginSelect;